import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { PopoverModule } from "ngx-bootstrap/popover";
import { TabsModule } from "ngx-bootstrap/tabs";

import { LearningObjectiveViewComponent } from "../learning-objective-view/learning-objective-view.component";
import { AssessmentResultService } from "../shared/services/assessment-result.service";
import { LearningObjectiveService } from "../shared/services/learning-objective.service";
import { SearchComponent } from "./../planning/search.component";
import { StatusButtonGroupComponent } from "./../shared/components/status-button-group.component";
import { UserService } from "./../shared/services/user.service";
import { LearningObjectiveFiltersComponent } from "./components/learning-objective-filters.component";
import { LearningObjectiveOrderPickerComponent } from "./components/learning-objective-order-picker.component";
import { StatusButtonComponent } from "./components/status-button.component";
import { LearningObjectiveOrderService } from "./services/learning-objective-order.service";
import { PlanningService } from "./services/planning.service";

import { PlanningHorizontalFiltersComponent } from "./components/planning-horizontal-filters.component";

// import { DndModule } from "ngx-drag-drop";
import { ModalComponent } from "../analytics-modal/modal.component";
import { AssignmentIndicatorComponent } from "../assignment-indicator/assignment-indicator.component";
import { NavbarComponent } from "../navbar/navbar.component";
import {
  ArraySortPipe,
  SafeHtmlPipe,
  TruncatePipe,
} from "./helpers/truncate.pipe";

import { FilterComponent } from "../planning/filters.component";
import { HorizontalFilterComponent } from "../planning/horizontal-filters.component";
import { PlannerIndicatorModule } from "./components/plannerindicator.component";
import { ScrollFixAreaDirective } from "./helpers/ScrollFixArea.directive";
import { AppDragFixLeftDirective } from "./helpers/ScrollFixLeft.directive";
import { ScrollWithElementDirective } from "./helpers/ScrollWithEl.directive";

import { RefreshVirtualScrollDirective } from "./helpers/RefreshVirtualScroll.directive";
import { InlineEditComponent } from "./inline-edit/inline-edit.component";

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    BsDropdownModule.forRoot(),
    PopoverModule.forRoot(),
    TabsModule.forRoot(),
    FormsModule,
    // DndModule,
    PlannerIndicatorModule,
    // ClickOutsideModule,
    FormsModule,
    ReactiveFormsModule,
    StatusButtonComponent,
    StatusButtonGroupComponent,
    TruncatePipe,
    SafeHtmlPipe,
    ArraySortPipe,
    LearningObjectiveFiltersComponent,
    LearningObjectiveViewComponent,
    NavbarComponent,
    ModalComponent,
    LearningObjectiveOrderPickerComponent,
    AssignmentIndicatorComponent,
    FilterComponent,
    SearchComponent,
    HorizontalFilterComponent,
    PlanningHorizontalFiltersComponent,
    AppDragFixLeftDirective,
    ScrollFixAreaDirective,
    RefreshVirtualScrollDirective,
    InlineEditComponent,
    ScrollWithElementDirective,
  ],
  providers: [PlanningService],
  // Standalone components, directives, and pipes are imported, not declared
  declarations: [],
  exports: [
    CommonModule,
    FormsModule,
    RouterModule,
    TranslateModule,
    BsDropdownModule,
    TabsModule,
    PlannerIndicatorModule,
  ],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        UserService,
        LearningObjectiveService,
        LearningObjectiveOrderService,
        AssessmentResultService,
      ],
    };
  }
}
